import React from 'react';
import { theme } from '../theme';

// ─── BentoCard ───────────────────────────────────────────
// Boundary signal: navy-tinted soft shadow (cardLifted) — static, no hover pop.
// No borders. Shadow gives separation from page bg without bento-box chrome.
// NavyKpiCard keeps its 2pt navy top-rule as the headline-tile signal — different visual register.
export const BentoCard: React.FC<{
  // ReactNode (not just string) so a loading consumer can pass a SkeletonBlock in place of the
  // title text (Task C) without BentoCard needing its own loading branch.
  title: React.ReactNode;
  children: React.ReactNode;
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  headerAction?: React.ReactNode;
}> = ({ title, children, style, contentStyle, headerAction }) => {
  return (
    <div
      data-card
      style={{
        backgroundColor: theme.colors.white,
        borderRadius: theme.borderRadius.md,
        boxShadow: theme.shadows.cardLifted,
        overflow: 'hidden',
        minWidth: 0,
        ...style,
      }}
    >
      <div style={{
        display: 'flex', alignItems: 'center',
        padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
        paddingBottom: theme.spacing.md,
        minWidth: 0,
      }}>
        <span style={{
          flex: 1, fontSize: 14, fontWeight: 600,
          color: theme.colors.navy, fontFamily: theme.font.family,
          userSelect: 'none',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {title}
        </span>
        {headerAction && (
          <div style={{ marginLeft: theme.spacing.sm, flexShrink: 0 }}>{headerAction}</div>
        )}
      </div>
      <div style={{ padding: theme.spacing.md, paddingTop: 0, overflow: 'hidden', ...contentStyle }}>{children}</div>
    </div>
  );
};
